<h2 mat-dialog-title class="dialog-title">
  <span class="dialog-title__text">Selected records</span>
  <span class="dialog-title__count" aria-label="Selected count">{{ selectedCount }}</span>
</h2>

<mat-dialog-content class="content">
  <div class="toolbar">
    <mat-form-field appearance="outline" class="mat-form-field-no-padding search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput type="text" [value]="filterValue" (input)="applyFilter($any($event.target).value)"
        placeholder="Search selected" />
      <button type="button" matSuffix mat-icon-button aria-label="Clear" *ngIf="filterValue"
        (click)="applyFilter('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <button class="clear-btn" mat-raised-button color="accent" (click)="clearAll()" [disabled]="selectedCount === 0">
      Clear selection
    </button>
  </div>

  <div *ngIf="selectedCount === 0" class="empty-state">
    0 selected
  </div>

  <div *ngIf="selectedCount > 0" class="table-scroll">
    <table mat-table [dataSource]="dataSource" matSort matSortDisableClear>
      <ng-container matColumnDef="Image">
        <th mat-header-cell *matHeaderCellDef>Preview</th>
        <td mat-cell *matCellDef="let record">
          <img
            class="thumb"
            [src]="record?.FacingAsset ? (record?.FacingAsset | offerPreview: PreviewMode.Thumbnail) : './assets/images/default-image.png'"
            alt="Offer image"
            (error)="onImageError($event)" />
        </td>
      </ng-container>

      <ng-container matColumnDef="Name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let record">{{ record?.Detail?.Name }}</td>
      </ng-container>

      <ng-container matColumnDef="Headline">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Headline</th>
        <td mat-cell *matCellDef="let record">{{ record?.Detail?.Headline }}</td>
      </ng-container>

      <ng-container matColumnDef="BodyCopy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Body Copy</th>
        <td mat-cell *matCellDef="let record">{{ record?.Detail?.BodyCopy }}</td>
      </ng-container>

      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef class="w-140">Actions</th>
        <td mat-cell *matCellDef="let record" class="w-140">
          <button mat-icon-button color="warn" (click)="remove(record)" matTooltip="Remove from selection">
            <mat-icon>close</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>

